<template>
  <v-row>
    <template v-if="showPresets">
      <v-col cols="12" class="caption pb-0">
        Colores prestablecidos
      </v-col>
      <v-col v-for="(preset, idx) in presets" :key="`preset-${idx}`" cols="4" md="3" lg="2">
        <v-card
          :ripple="!disabled"
          @click="onPresetClick(preset)"
          :style="`background: ${colorArrayToLinearGradient(preset.colors, 135)} !important;`"
          :class="['d-flex align-center preset-card', { disabled },  { selected: JSON.stringify(preset.colors) === JSON.stringify(colors)}]"
          height="50"
        >
          <v-spacer/>
          <v-card-title class="font-weight-light caption white--text preset">{{preset.name}}</v-card-title>
          <v-spacer/>
        </v-card>
      </v-col>
    </template>

    <template v-if="colors.length > 0 && minColors > 0 && maxColors > 0 ">
      <v-col cols="12" class="caption pb-0">
        Editar colores
      </v-col>

      <v-col cols="12">
        <kyra-color-picker
          inline
          :clear-btn="colors.length > minColors"
          v-for="(color, idx) in colors"
          :key="`color-${idx}`"
          :value="color"
          :label="`color ${idx + 1}`"
          @click:clear="removeColor(idx)"
          @change="onColorEdit(idx, $event)"
        />

        <v-btn
          v-if="colors.length < maxColors"
          fab x-small class="ml-1"
          @click="addColor"
        >
          <v-icon>add</v-icon>
        </v-btn>

      </v-col>
    </template>

  </v-row>
</template>

<script>

  import {colorArrayToLinearGradient} from "@/utils/UI";
  import KyraColorPicker from "@/components/common/KyraColorPicker.vue";
  import {ColorSchemes} from "@/utils/UI";

  export default {
    name: 'ColorArrayPicker',
    components: {KyraColorPicker},
    props: {
      showPresets: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      minColors: {
        type: Number,
        default: 2
      },
      maxColors: {
        type: Number,
        default: 5
      },
      allowAdd: {
        type: Boolean,
        default: false
      },
      value: {
        type: Array,
        default: () => []
      }
    },
    mounted() {
      const vm = this
      vm.colors = [...vm.value]
    },
    data(){
      return {
        colors: [],
        presets: [
          {
            name: "Kyra",
            colors: ColorSchemes.Kyra,
          },
          {
            name: "Sunrise",
            colors: ColorSchemes.Sunrise
          },
          {
            name: "Ocean",
            colors: ColorSchemes.Ocean,
          },
          {
            name: "Forest",
            colors: ColorSchemes.Forest,
          },
          {
            name: "Desert",
            colors: ColorSchemes.Desert
          },
          {
            name: "Aurora",
            colors: ColorSchemes.Aurora,
          }
        ]
      }
    },
    methods: {
      colorArrayToLinearGradient,
      onPresetClick(val){
        const vm = this
        if(vm.disabled) return

        if(val.colors.length <= vm.maxColors){
          vm.colors = [...val.colors]
          vm.$nextTick(() => {
            vm.$emit('change', vm.colors)
          })
          return
        }

        vm.colors = val.colors.slice(0, vm.maxColors)
        vm.$nextTick(() => {
          vm.$emit('change', vm.colors)
        })
      },
      addColor(){
        const vm = this
        vm.colors.push('#FFFFFF')
      },
      removeColor(idx){
        const vm = this
        vm.colors.splice(idx, 1)
        vm.$nextTick(() => {
          vm.$emit('change', vm.colors)
        })
      },
      onColorEdit(idx, color){
        const vm = this
        vm.colors.splice(idx, 1, color)
        vm.$nextTick(() => {
          vm.$emit('change', vm.colors)
        })
      }
    },
    watch:{
      maxColors(val){
        const vm = this
        if(vm.colors.length <= val){
          return
        }
        vm.colors = vm.colors.slice(0, val)
      },
      value(val){
        const vm = this
        vm.colors = [...val]
      }
    }
  }
</script>

<style scoped>

  .preset-card{
    border-radius: 10px;
    border: 2px solid transparent;
  }

  .preset-card.selected{
    border: 2px solid var(--v-accent-base);
  }

  .preset-card.disabled{
    opacity: 0.7;
    border: 2px solid transparent;
    filter: grayscale(1);
    cursor: default;
  }

  .preset{
    text-shadow: 4px 4px 5px #000 !important;
  }

</style>